import styled from '~/app/components/styled'
import { Typography } from '@yanolja-rnd/ya-com-core'

export default styled.section`
  & + & {
    margin-top: 0.8rem;
  }
  color: ${p => p.theme.color.gray900};
  background-color: ${p => p.theme.color.white};
  ${Typography('subtitle3').regular};
`

export const SectionBody = styled.div`
  padding: 0 2rem 2rem;
`
